import { matchPath } from 'react-router-dom';
import { ADMIN_PAGES, AdminPage, navPathOf } from './adminPages';

// Per-admin convenience for Home's "Recently visited": kept in this browser only,
// so every read and write tolerates storage being unavailable.
const STORAGE_KEY = 'home.recentPages';
const MAX_RECENT = 6;

const listedPageAt = (pathname: string) =>
  ADMIN_PAGES.find(
    page => page.label && !page.account && matchPath(page.path, pathname),
  );

/** Nav paths of the pages opened most recently, newest first. */
export function readRecentPaths(): string[] {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(stored)
      ? stored.filter(path => typeof path === 'string')
      : [];
  } catch {
    return [];
  }
}

export function recordVisit(pathname: string) {
  const page = listedPageAt(pathname);
  if (!page) return;
  const path = navPathOf(page);
  try {
    const rest = readRecentPaths().filter(recent => recent !== path);
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([path, ...rest].slice(0, MAX_RECENT)),
    );
  } catch {
    // Storage is blocked or full; recents are optional.
  }
}

export const pageAtNavPath = (path: string): AdminPage | undefined =>
  ADMIN_PAGES.find(page => page.label && navPathOf(page) === path);
